import { Chart } from 'chart.js'
import { prefersDark } from './colorScheme'

export type ChartPalette = {
  forest: string
  forestLight: string
  forestFill: string
  amber: string
  rose: string
  sky: string
  /** Validated categorical pair for RPAA vs trials (light and dark steps). */
  rpaa: string
  trials: string
  /** Validated 4-slot order for activation steps (light and dark steps). */
  steps: { inbox_connected: string; trial_started: string; activated: string; paid: string }
  gray100: string
  gray400: string
  gray800: string
  tooltipBg: string
  tooltipFg: string
  tooltip: {
    backgroundColor: string
    titleColor: string
    bodyColor: string
    padding: number
    cornerRadius: number
  }
}

export function chartPalette(): ChartPalette {
  const dark = prefersDark()
  const forest = dark ? '#4ade80' : '#004d16'
  const gray800 = dark ? '#f4f4f5' : '#1f2937'
  const tooltipFg = '#f9fafb'
  return {
    forest,
    forestLight: '#22c55e',
    forestFill: dark ? 'rgba(74, 222, 128, 0.12)' : 'rgba(0, 77, 22, 0.08)',
    amber: '#d97706',
    rose: '#e11d48',
    sky: '#0284c7',
    rpaa: dark ? '#16a34a' : '#15803d',
    trials: '#0284c7',
    steps: {
      inbox_connected: '#0284c7',
      trial_started: dark ? '#ea580c' : '#c2410c',
      activated: dark ? '#8b5cf6' : '#7c3aed',
      paid: dark ? '#16a34a' : '#15803d',
    },
    gray100: dark ? '#3f3f46' : '#f3f4f6',
    gray400: dark ? '#a1a1aa' : '#9ca3af',
    gray800,
    tooltipBg: dark ? '#27272a' : '#1f2937',
    tooltipFg,
    tooltip: {
      backgroundColor: dark ? '#27272a' : '#1f2937',
      titleColor: tooltipFg,
      bodyColor: tooltipFg,
      padding: 10,
      cornerRadius: 8,
    },
  }
}

export function applyChartDefaults() {
  const p = chartPalette()
  Chart.defaults.color = p.gray400
  Chart.defaults.borderColor = p.gray100
}
